import { ShoppingCartIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Shop = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <ShoppingCartIcon size={Sizes[size]} {...rest} color={fill} />;
};

Shop.displayName = 'Shop';
